import Icon from '../components/Icon.vue'

Icon.register({
  'grip-vertical': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M96 32H32C14.3 32 0 46.3 0 64V128C0 145.7 14.3 160 32 160H96C113.7 160 128 145.7 128 128V64C128 46.3 113.7 32 96 32zM96 192H32C14.3 192 0 206.3 0 224V288C0 305.7 14.3 320 32 320H96C113.7 320 128 305.7 128 288V224C128 206.3 113.7 192 96 192zM96 352H32C14.3 352 0 366.3 0 384V448C0 465.7 14.3 480 32 480H96C113.7 480 128 465.7 128 448V384C128 366.3 113.7 352 96 352zM288 32H224C206.3 32 192 46.3 192 64V128C192 145.7 206.3 160 224 160H288C305.7 160 320 145.7 320 128V64C320 46.3 305.7 32 288 32zM288 192H224C206.3 192 192 206.3 192 224V288C192 305.7 206.3 320 224 320H288C305.7 320 320 305.7 320 288V224C320 206.3 305.7 192 288 192zM288 352H224C206.3 352 192 366.3 192 384V448C192 465.7 206.3 480 224 480H288C305.7 480 320 465.7 320 448V384C320 366.3 305.7 352 288 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grip-vertical.js
// module id = H7Zb
// module chunks = 144